import React from 'react'

const ExpenseReport = () => {
  return (
    <>
      <div className="pagetitle">
        <h1>Expense Report</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item">Expenses</li>
            <li className="breadcrumb-item active">Expense Report</li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Expense Report</h5>
                <p>Expense report content will be displayed here.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default ExpenseReport

